module.exports = __webpack_public_path__ + "img/q3.0ca3f8d7.png";